















import {Component, Mixins, Prop, Vue} from 'vue-property-decorator';
import TextProviderMixin from "@/design-system/utilities/TextProviderMixin"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import {ActiveProvide} from "@/support/reactive"

// Deprecated! -- use the specific Field components instead.
@Component
export default class JdsField extends Mixins(TextProviderMixin, UniqueIdMixin)  {
    @ActiveProvide('jds.text-input.width') inputWidth = '100%';

    @Prop({default: false, type: Boolean}) set!: boolean;
}
